/**
 * This provider always holds the most recent firebase user information. On every change it is updated properly.
 * Elements wrapped in the FirebaseAuthProvider tag can access the context and thus the user information.
 * This prevents us from passing the user property to all required elements and this makes it less complex.
 *
 * Whenever the value in the provider changes (i.e. the currentUser is changed), the consumers will also re-render.
 *
 * TODO: modify description (has been simply copied...)
 */

import React, {useRef, useState} from "react"

export const AppbarContentContext = React.createContext()

export const AppbarContentProvider = ({children}) => {
    const [currentAppbarContent, setCurrentAppbarContent] = useState({
        header: '',
        description: '',
        actions: <div></div>,
        progress: false
    });

    const [isDrawerOpen, setIsDrawerOpen] = useState(true)

    const jobQueue = useRef({})
    const [backgroundJobs, setBackgroundJobs] = useState({})

    // Executes a background job, which will be indicated in the appbar
    const startBackgroundJob = (id, tooltip, job, progress) => {

        // Register the new job
        jobQueue.current = {
            ...jobQueue.current,
            [id]: {
                tooltip: tooltip,
                progress: progress.current
            }
        }
        setBackgroundJobs({...jobQueue.current})

        // Register polling for upload progress
        let interval = setInterval(async () => {
            jobQueue.current[id].progress = progress.current
            setBackgroundJobs({...jobQueue.current})
        }, 1000);

        // Execute the job and remove it after it is finished
        job()
            .then(() => {
                // Wait 5 seconds to allow showing of the success icons (in case 100%)
                return new Promise((resolve) => {
                    setTimeout(resolve,5000);
                });
            })
            .finally(() => {
                delete jobQueue.current[id]
                setBackgroundJobs({...jobQueue.current})

                clearInterval(interval)
            })
    }

    // Important: all sub-components need to be wrapped into it
    return (
        <AppbarContentContext.Provider
            value={{
                currentAppbarContent,
                setCurrentAppbarContent,
                isDrawerOpen,
                setIsDrawerOpen,
                backgroundJobs,
                startBackgroundJob
            }}>
            {children}
        </AppbarContentContext.Provider>
    );
};